import React, { forwardRef } from 'react';
import HBDatepicker, { HBDatepickerProps } from '../HBDatepicker/HBDatepicker';
import HBDatepickerField, {
    HBDatepickerFieldProps
} from '../HBDatepickerField/HBDatepickerField';
import useFormFieldProps, {
    FormFieldProps,
    useFormInputProps,
    useFormInputValidationProps
} from './useFormFieldProps';
import { useGetDateFormat } from '@honeybook/i18n-react';

const HBFormDatepickerField = (
    props: FormFieldProps<HBDatepickerFieldProps>
) => {
    const fieldProps = useFormFieldProps(props);
    const validationProps = useFormInputValidationProps(props.id);
    const { dateFormatMedium: defaultFormat } = useGetDateFormat();

    return (
        <HBDatepickerField
            {...fieldProps}
            {...validationProps}
            dateFormat={fieldProps.dateFormat || defaultFormat}
        />
    );
};

export const HBFormDatepicker = forwardRef<
    HTMLInputElement,
    FormFieldProps<HBDatepickerProps>
>((props, ref) => {
    const inputProps = useFormInputProps(props);

    return <HBDatepicker {...inputProps} ref={ref} />;
});

export default HBFormDatepickerField;
